module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/uRoxh3/tc-custom/9781449474539.jpg?1738496185482",
      "alt": "This image is the cover for the book No Yelling!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("No Yelling!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("This collection from the popular comic strip offers hilarious insight into the ups and downs of modern parenting.")]), _c('br'), _c('br'), _vm._v(" For more than twenty-five years, the MacPherson family has brought the joy, humor, and poignancy of raising three children to funny pages worldwide. "), _c('i', [_vm._v("No Yelling!")]), _vm._v(" shines a comedic light on everything from dealing with picky eaters to the consequences of too much screen time. From gargantuan messes to legendary sibling disputes the MacPhersons manage to overcome many of life's hurdles."), _c('br'), _c('br'), _vm._v(" With witty and informative commentary from the co-creators themselves, this collection will appeal to anyone who has kids or who remembers what it was like to be one. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Rick Kirkman, Jerry Scott\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Rick Kirkman's work on Baby Blues has delighted fans and wowed the cartooning world since he launched the strip with Jerry Scott in 1990. Rick lives in Phoenix, Arizona. Online: babyblues.comJerry Scott is the co-creator of the award-winning comic strip Zits. He lives in central coastal California. Jerry's work on Baby Blues has delighted fans and wowed the cartooning world since he launched the strip with Rick Kirkman in 1990.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Andrews McMeel Publishing, LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0